<template>
  <div class="p-2 bg-gray-200 dark:bg-gray-900">
    <orderDetail
      :rowId="selected.id"
      @isNewOrder="(val) => (isNewOrder = val)"
      @refresh="addrefresh()"
      ref="orderDetail"
      @orderList="(val) => (orderList = val)"
      @isLaterAddOrder="(val) => (isLaterAddOrder = val)"
      :isDisabled="
        ((selected.tonnage && selected.receivedTonnage ? selected.tonnage <= selected.receivedTonnage && !selected.isLastTour : false) || (selected.isEvacuationEnd==1)) 
      "
    />

    <notesModal
      :orderStatus="'Gemi Siparişi'"
      :key="'gemiNotesModalKey'"
      :type="'gemi'"
      :evacuationId="selected?.id"
    />
    <addModal
      :isNewOrder="isNewOrder"
      :orderCount="selected.planCount"
      @refresh="addrefresh()"
      :isLaterAddOrder="isLaterAddOrder"
    />
    <vehicleModalVue
      @refresh="getAll()"
      :rowId="selected.id"
      :orderNo="selected.orderNo"
      :order="orderList && orderList.length > 0 ? orderList[0] : {}"
      :isDisabled="
        selected.tonnage && selected.receivedTonnage ? selected.tonnage <= selected.receivedTonnage && !selected.isLastTour : false
      "
      :isManualMode="selected.manualAssignmentMode == 1"
    />
    <div class="w-full">
      <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
        <div class="w-full">
          <LyrausTable
            :data="List"
            :columns="columns"
            :enablePagination="true"
            :isLoading="load"
            :batchOperations="!isArchived"
            :searchBar="true"
            :searchProp="search"
            @update-search-value="(val) => handleSearchValue(val)"
            :handleSearch="handleSearch"
            :alternateRowBg="['white', 'gray-100']"
            :pageCount="pageCount"
            :pageProp="currentPage"
            @update-current-page="handleCurrentPage"
            :totalCount="totalCount"
            :paginationButtonColor="'red-600'"
            :paginationHoverColor="'red-700'"
            :tdClass="'whitespace-nowrap border-gray-200 text-xs py-1'"
            :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
          >
            <template v-slot:searchBar> <SearchInput :value="search" :isFull="true" @searcing="(val) => {handleSearchValue(val); handleSearch();}" /> </template>
            <template v-slot:rowButtons="{ item, columnKey }">
              <button
                v-if="columnKey === 'manualAssignmentMode'"
                class="flex items-center justify-center border rounded-lg space-x-2 px-2 py-1 mx-2"
                :class="
                  item.manualAssignmentMode == 1
                    ? 'bg-green-100'
                    : 'bg-gray-100'
                "
                @click="toggleManualMode(item)"
                :disabled="true"
                :title="'Manuel Atama Modu aktif olarak ayarlanmış, değiştirilemiyor'"
              >
                <span
                  :class="
                    item.manualAssignmentMode == 1
                      ? 'text-green-600'
                      : 'text-gray-600'
                  "
                >
                  {{ item.manualAssignmentMode == 1 ? "Aktif" : "Kapalı" }}
                </span>
                <i
                  class="fas"
                  :class="
                    item.manualAssignmentMode == 1
                      ? 'fa-toggle-on text-green-600'
                      : 'fa-toggle-off text-gray-600'
                  "
                ></i>
                <i class="fas fa-lock ml-1 text-gray-500" title="Bu ayar şu anda değiştirilemiyor"></i>
              </button>
              <button
                v-if="columnKey === 'totalVehicles'"
                @click="showVehicleList(item)"
              >
                <div
                  class="flex items-center justify-center border rounded-lg w-8 h-6"
                  :class="
                    item.rejectStatus > 0
                      ? 'animate-pulse border-red-400 bg-red-400 text-gray-100'
                      : 'border-gray-400'
                  "
                >
                  {{ item.totalVehicles }}
                </div>
              </button>
              <div v-if="columnKey === 'tonnage'">
                {{
                  item.tonnage
                    ? Math.ceil(item.tonnage) +
                      " / " +
                      Math.max(0, item.tonnage - (item.receivedTonnage || 0)).toFixed(2)
                    : "0 / 0"
                }}
              </div>
              <div v-if="columnKey === 'process'">
                <div class="flex items-center space-x-2">
                  <!-- Tahliye tamamlandıysa hiçbir buton gösterme -->
                  <template v-if="((!item.tonnage || item.tonnage === 0) && (item.isEvacuationEnd!=1))">
                    <!-- Tamamla Butonu - Sadece manuel mod ve tahliye başlamışsa -->
                    <asyncBtn
                      v-if="(!item.tonnage || item.tonnage === 0)"
                      @click="completeEvacuation(item)"
                      :loadState="load"
                      text="Tamamla"
                      icon="fas fa-check"
                      size="py-1 "
                      containerClass="bg-blue-600 hover:bg-blue-700 w-32"
                    />
                  </template>
                  <template v-else>
                    <span class="text-gray-400 text-sm">-</span>
                  </template>
                </div>
              </div>
              <div v-if="columnKey === 'stateId'">
                <StatusCell 
                  :item="item" 
                  :loadState="load" 
                  @start-ship="startShip"
                />
              </div>
              <div v-if="columnKey === 'operations'">
                <div class="flex items-center justify-center">
                  <button
                    class="mx-2"
                    :class="item.explanation == '' ? 'opacity-20' : ''"
                    @click="item.explanation == '' ? '' : noteDetailModal(item)"
                  >
                    <img
                      class="w-4 h-4"
                      src="../../../assets/ship/note.svg"
                      alt=""
                    />
                  </button>
                  <button class="mx-2" @click="orderDetail(item)">
                    <img
                      class="w-4 h-4"
                      src="../../../assets/ship/diagram.png"
                      alt=""
                    />
                  </button>
                  <button class="mx-2" @click="deleteItem(item)" :disabled="isArchived" :class="isArchived ? 'opacity-30 cursor-not-allowed' : ''">
                    <i class="fas fa-trash text-gray-700"></i>
                  </button>
                </div>
              </div>
            </template>
            <template v-slot:batchOperations>
              <asyncBtn
                v-if="!isArchived"
                icon="fas fa-plus "
                text="Yeni Gemi Tahliyesi"
                class="w-36 btn"
                @click="
                  () => (
                    (isNewOrder = 0),
                    (isLaterAddOrder = false),
                    $modal.show('add-plan-modal')
                  )
                "
              />
            </template>
          </LyrausTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Npm
import moment from "moment";

// Global Components
import noteDetail from "@/components/modals/noteDetail/index.vue";
import SearchInput from "@/components/general/search-input.vue";
// Local Components
import asyncBtn from "../../../components/general/asyncBtn.vue";
import orderDetail from "./components/orderDetail/index.vue";
import addModal from "./components/add/index.vue";
import vehicleModalVue from "./components/vehicle-list/index.vue";
import notesModal from "../../../components/modals/notesModal/index.vue";
import StatusCell from "./components/status/StatusCell.vue";
// networking
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
export default {
  name: "shipEvacuationPlannig-module",
  props: {
    isArchived: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    addModal,
    vehicleModalVue,
    orderDetail,
    asyncBtn,
    noteDetail,
    notesModal,
    StatusCell,
    SearchInput
  },
  data() {
    return {
      needInterval: true, // app.vue da setInterval için lazım silme
      filterState: false, //Kullanılmıyor ?
      // isFullScreen: false,
      List: [],
      note: "",
      columns: [
        {
          key: "id",
          label: "#",
        },
        {
          key: "name",
          label: "Gemi İsmi",
          maxLength: 30,
          tooltip: true,
        },
        {
          key: "startedDate",
          label: "Başlangıç Tarihi",
          isDate: true,
        },
        {
          key: "complatedDate",
          label: "Bitiş Tarihi",
          isDate: true,
        },
        {
          key: "minVehicleCount",
          label: "Min. Araç Sayısı",
        },
        {
          key: "potCount",
          label: "Pot Sayısı",
        },
        {
          key: "manualAssignmentMode",
          label: "Manuel Mod",
          formatter: (val) => (val ? "Açık" : "Kapalı"),
          dontDisplay: true,
        },
        {
          key: "totalVehicles",
          label: "Araçlar",
          dontDisplay: true,
          center: true,
        },
        {
          key: "tonnage",
          label: "Toplam / Kalan",

          dontDisplay: true,
        },
        {
          key: "stateId",
          label: "Durum",
          dontDisplay: true,
          center: false,
        },
        {
          key: "process",
          label: "Tahliye Durumu",
        },
        {
          key: "operations",
          label: "İşlemler",
          dontDisplay: true,
          center: true,
        },
      ],
      load: false,
      search: "",
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      selected: { id: "", plaque: "", vehicleId: "" },
      isNewOrder: "",
      orderList: "",
      //Siparişin Sonradan eklenip eklenmediğine bakıyor true ise sipariş sonradan eklenmiştir
      isLaterAddOrder: false,
    };
  },
  methods: {

    noteDetailModal(item) {
      this.note = item.explanation;
      this.selected = item;
      this.$modal.show("notes-modal");
    },
    addrefresh() {
      this.getAll();
      this.$refs.orderDetail.showRefresh();
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    orderDetail(item) {
      this.selected = item;
      this.$modal.show("orderDetail-modal");
    },
    startShip(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Planı başlatmak istediğinize emin misiniz?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          axios
            .post(
              bulkShipPlanning.startShip,
              {
                shipId: item.id,
              },

              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );

              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      });
    },
    
    // Manuel atama modunu aç/kapa
    toggleManualMode(item) {
      // Bilgilendirme mesajı göster
      this.swalBox(
        "info",
        "Manuel Atama Modu",
        "Manuel Atama Modu aktif olarak ayarlanmış, değiştirilemiyor",
        false,
        this.$t("general.OkayTitle")
      );
    },
    showVehicleList(item) {
      this.selected = item;
      this.$modal.show("vehicle-list-modal");
      setTimeout(() => {
        this.$refs.orderDetail.getAll();
      }, 100);
    },
    handleSearchValue(val) {
      this.search = val;
    },
    handleSearch() {
      this.clickSearch = false;
      this.searchColumn = "";
      this.currentPage = 0;
      this.getAll();
    },
    handleCurrentPage(val) {
      this.currentPage = val;
    },
    async getStatusController() {
      try {
        await axios.get(bulkShipPlanning.getActionController, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        });
      } catch (error) {
        console.error("Error fetching status controller:", error);
        this.swalBox(
          "warning",
          "UYARI!",
          "Durum Kontrol Sistemi başlatılamadı,Lütfen daha sonra tekrar deneyiniz!"
        );
      }
    },
     // Tahliyeyi Tamamla - Manuel Mod
    async completeEvacuation(item) {
      const remainingTonnage = Math.max(0, item.tonnage - (item.receivedTonnage || 0)).toFixed(2);
      const result = await this.swalBox(
        "warning",
        "Tahliyeyi Tamamla",
        `${item.name} isimli depoyu tamamlamak istediğine emin misiniz? Kalan tonaj: ${remainingTonnage}`,
        true,
        "Evet, Tamamla",
        "İptal"
      );

      if (result.isConfirmed) {
        this.load = true;
        try {
          await axios.post(
            bulkShipPlanning.completeEvacuation,
            { 
              shipId: item.id,
              orderNo: item.orderNos
            },
            {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            }
          );

          this.swalBox(
            "success",
            "Başarılı",
            "Tahliye başarıyla tamamlandı",
            false,
            this.$t("general.OkayTitle")
          );
          this.getAll();
        } catch (err) {
          this.errorBox(err.response);
        } finally {
          this.load = false;
        }
      }
    },
    async changeProcess(item) {
      this.selected = item;
      if (item.evacuationState === 2) {
        // Manuel modda ve tonaj düşmüşse ekstra uyarı ver
        if (item.manualAssignmentMode == 1 && item.receivedTonnage > 0) {
          const extraWarning = await this.swalBox(
            "warning",
            "⚠️ DİKKAT: ARAÇLAR YOLA ÇIKMIŞ!",
            `Tahliye devam ediyor ve ${item.receivedTonnage.toFixed(2)} TON tonaj zaten yola çıkmış durumda. Kalan tonaj: ${(item.tonnage - item.receivedTonnage).toFixed(2)} TON Yine de durdurmak istediğinize emin misiniz?`,
            true,
            "Evet, Durdur",
            "İptal"
          );

          if (!extraWarning.isConfirmed) {
            return; // Kullanıcı iptal etti
          }
        }

        const result = await this.swalBox(
          "warning",
          "UYARI !",
          "Tahliyeyi durdurmak istediğinize emin misiniz?",
          true,
          "Evet, eminim",
          "Hayır, değilim"
        );

        if (result.isConfirmed) {
          const params = {
            typeId: 1,
            shipId: item.id,
          };
          axios
            .post(bulkShipPlanning.process, params, {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            })
            .then(() => {
              this.addrefresh();
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      } else {
        this.$modal.show("storage-process-modal");
      }
    },
    getAll(load = true) {
      if (load) {
        this.List = [];
        this.load = load;
      }
      let url = bulkShipPlanning.getAll +
            "?page=" +
            this.currentPage +
            "&search=" +
            this.search +
            "&typeId=" +
            1;
      if (this.isArchived) {
        url += "&isArchived=true";
      }
      axios
        .get(
          url,
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(async (res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;

          this.load = false;
        })
        .catch((err) => {
          this.errorBox(err.response);
          this.load = false;
        });
    },
    deleteItem(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Planı silmek istediğinize emin misiniz ?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          axios
            .post(
              bulkShipPlanning.delete,
              {
                rowId: item.id.toString(),
              },

              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );

              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.$store.state.intervalId);
  },
  created() {
    this.getAll();
  },
  filters: {
    getDateFormat(val) {
      return moment.utc(val).format("LLL");
    },
  },
  watch: {
    currentPage() {
      this.getAll();
    },
    filterState(val) {
      if (!val) this.getAll();
    },
  },
};
</script>
